export default "__VITE_ASSET__aAN63jjX__"